import { API } from './index';

/**
 * Creates a Stripe checkout session for subscription
 * @param priceId - The Stripe price ID for the subscription plan
 * @returns Promise with checkout session URL
 */
export const createCheckoutSession = async (priceId: string) => {
  try {
    const response = await API.post('/api/v1/stripe/create-checkout-session', {
      priceId,
      successUrl: `${window.location.origin}/subscription-success`,
      cancelUrl: `${window.location.origin}/subscription-cancelled`,
    });

    return response.data;
  } catch (error: any) {
    console.error('Error creating checkout session:', error);
    throw error.response?.data || error;
  }
};

/**
 * Creates a Stripe billing portal session for subscription management
 * @returns Promise with billing portal URL
 */
export const createBillingPortalSession = async () => {
  try {
    const response = await API.post('/api/v1/stripe/create-portal-session', {
      returnUrl: window.location.href,
    });

    return response.data;
  } catch (error: any) {
    console.error('Error creating billing portal session:', error);
    throw error.response?.data || error;
  }
};
